import { atom } from 'recoil';

export const downloadLoadingState = atom({
  key: 'downloadLoadingState',
  default: false,
});
